import React from 'react';
import Article from '../../../components/ui/article/Article';

const News =(props)=> {
    return (
        <Article ></Article>
        );
}
export default News;